import io from 'socket.io-client'

export const auctionSocketMixin = {
  data() {
    return {
      socket: null,
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
    getAuctionById() {
      return this.$store.getters['auction/getAuctionRowById'];
    },
    auction() {
      return this.$store.getters['auction/auction'];
    }
  },
  methods: {
    initSocket(url = null) {
      if (this.socket !== null) {
        return
      }

      try {
        this.socket = io(url || '/', {
          transports: ["websocket"],
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
        })

        this.socket.on('connect', () => {
          this.$store.dispatch('auction/setSocketStatus', true)
        })

        this.socket.on('disconnect', () => {
          this.$store.dispatch('auction/setSocketStatus', false)
          console.log('Socket disconnected')
        })

        this.socket.on('auctionList', (auctionData) => {

          const updatedRows = auctionData.rows.map(item => {
            if (item.user_id === this.me.id) {
              return { ...item, lastMyBid: item.price, isMy: true };
            } else {
              const auctionRowData = this.getAuctionById(item.id)

              const mergeData = {isMy: false}
              if (auctionRowData) {
                mergeData.lastMyBid = auctionRowData.lastMyBid
              }

              return { ...item, ...mergeData };
            }
          });

          this.$store.dispatch('auction/setAuctions', { ...this.auction, ...auctionData, rows: updatedRows })
        })

        this.socket.on('rowUpdate', (data) => {
          if (data.user_id === this.me.id) {
            data.lastMyBid = data.price
            data.isMy = true
          } else {
            data.isMy = false
          }

          this.$store.dispatch('auction/updateAuctionRow', data)
        })

        this.socket.on('error', (data) => {
          this.$notify({ group: 'foo', type: 'error', text: data.message })

          if (data.redirect) {
            this.$router.push(data.redirect)
          }
        })

        this.socket.on('connect_error', (error) => {
          console.error('Socket connection error:', error)
          this.$store.dispatch('auction/setSocketStatus', false)
        })

      } catch (error) {
        console.error('Failed to initialize socket:', error)
      }
    },

    disconnectSocket() {
      if (this.socket) {
        this.socket.disconnect()
        this.socket = null
        this.$store.dispatch('auction/setSocketStatus', false)
      }
    },
    emitBid(auctionRowId, amount) {
      this.socket.emit('placeBid', {
        auctionRowId,
        bidAmount: amount,
      })
    },
    emitPage(page) {
      this.socket.emit('auctionPage', {
        auction_id: this.$store.getters['auction/auction'].id,
        page: page,
      })
    },
  },
  beforeDestroy() {
    this.disconnectSocket()
  }
}
